// Add your custom JS here.

(function ($) {
  $(document).ready(function () {
    $('li.menu-item-has-children > a').after(
      '<span class="new-span d-xl-none"><i class="fa fa-angle-down" aria-hidden="true"></i></span>'
    );

    $('li.menu-item-has-children > span.new-span').click(function () {
      $(this).closest('li').children('ul').toggleClass('show');
      $(this).closest('li').children('.new-span').toggleClass('active');
    });
  });
})(jQuery);
